import { EBAY_CHANNEL_ID, SHOPGOODWILL_CHANNEL_ID } from './types'

export const EXPRESS_LIST_CHANNEL_IDS = [SHOPGOODWILL_CHANNEL_ID, EBAY_CHANNEL_ID]

export type CategoryMapping = {
  active: boolean
  categoryMarketCategory: {
    id: number
    marketId: number
    pathCache: string
    isLeaf?: boolean
  }
}

export const expressListMarketIds = (connectedMarkets: { id?: number; marketId?: number }[] = []) => {
  const connectedIds = new Set(connectedMarkets.map(cm => cm.id ?? cm.marketId))
  return EXPRESS_LIST_CHANNEL_IDS.filter(id => connectedIds.has(id))
}

export const findActiveCmc = (categoryMappings: CategoryMapping[] | undefined, marketId: number) => {
  return categoryMappings?.find(cm => cm.active && cm.categoryMarketCategory?.marketId === marketId)
    ?.categoryMarketCategory
}

export const marketChannelLabel = (marketId: number) => {
  if (marketId === SHOPGOODWILL_CHANNEL_ID) return 'SHOPGOODWILL'
  if (marketId === EBAY_CHANNEL_ID) return 'EBAY'
  return 'MARKETPLACE'
}

export const hasShopgoodwillChannel = (channelIds: number[]) => channelIds.includes(SHOPGOODWILL_CHANNEL_ID)

export const hasEbayChannel = (channelIds: number[]) => channelIds.includes(EBAY_CHANNEL_ID)
